import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { AppBar, Toolbar } from '@mui/material';
// import styles from './styles.module.css';
// import useClasses from '../../../../helpers/useClasses';

// const styles = theme => ({
//   root: {
//     boxShadow: 'none',
//     backgroundColor: '#fff'
//   }
// });

const Topbar = props => {
  const { className, ...rest } = props;

  // const classes = useClasses(styles);

  return (
    <AppBar
      {...rest}
      // className={clsx(classes.root, className)}
      color="primary"
      position="fixed"
      // className={styles.root}
      sx={{
        boxShadow: 'none',
        backgroundColor: '#fff'
      }}
    >
      <Toolbar>
        <RouterLink to="/login">
          <img
            alt="Logo"
            src="/images/logos/logo.png"
            height="40px"
          />
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string
};

export default Topbar;
